import React from 'react';
import { FiClipboard, FiTarget } from 'react-icons/fi';
import styled from 'styled-components';

const Section = styled.section`
  padding: 4rem 0;
  background: ${props => props.theme.colors.surface};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const SectionTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes['4xl']};
  font-weight: ${props => props.theme.fontWeights.bold};
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: ${props => props.theme.colors.secondary};
    border-radius: 2px;
  }
`;

const SectionSubtitle = styled.p`
  font-size: ${props => props.theme.fontSizes.lg};
  color: ${props => props.theme.colors.textSecondary};
  max-width: 600px;
  margin: 0 auto;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
`;

const ContentCard = styled.div`
  background: ${props => props.theme.colors.background};
  padding: 2.5rem;
  border-radius: ${props => props.theme.borderRadius.xl};
  box-shadow: ${props => props.theme.shadows.lg};
  border-left: 5px solid ${props => props.theme.colors.primary};
  transition: ${props => props.theme.transitions.base};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: ${props => props.theme.shadows.xl};
  }
`;

const CardTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes['2xl']};
  font-weight: ${props => props.theme.fontWeights.semibold};
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const CardIcon = styled.div`
  width: 40px;
  height: 40px;
  background: ${props => props.theme.colors.secondary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.primary};
  font-size: 1.25rem;
  font-weight: bold;
`;

const CardContent = styled.div`
  font-size: ${props => props.theme.fontSizes.base};
  line-height: 1.8;
  color: ${props => props.theme.colors.text};
  
  p {
    margin-bottom: 1rem;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const CourseOverview = ({ courseDetail }) => {
  if (!courseDetail) return null;

  return (
    <Section>
      <Container>
        <SectionHeader>
          <SectionTitle>Course Overview</SectionTitle>
          <SectionSubtitle>
            Comprehensive information about {courseDetail.courseTitle}
          </SectionSubtitle>
        </SectionHeader>
        
        <ContentGrid>
          <ContentCard>
            <CardTitle>
              <CardIcon><FiClipboard /></CardIcon>
              About The Certification
            </CardTitle>
            <CardContent>
              <p>{courseDetail.aboutCertification}</p>
            </CardContent>
          </ContentCard>
          
          <ContentCard>
            <CardTitle>
              <CardIcon><FiTarget /></CardIcon>
              Scope of Work
            </CardTitle>
            <CardContent>
              <p>{courseDetail.scopeOfWork}</p>
            </CardContent>
          </ContentCard>
        </ContentGrid>
      </Container>
    </Section>
  );
};

export default CourseOverview; 